import { User } from '@/types/user'
import { CRUDService } from '@/services/CRUD'
import { ICRUDService } from '@/services/types'

export class UsersService extends CRUDService implements ICRUDService<User> {
  static async get() {
    return await this.handlePromise<User>(this.api.get<User>('/account'))
  }
}
